import axios from 'axios';

const getBaseUrl = () => {
    const host = window.location.hostname;
    const protocol = window.location.protocol;

    if (host === 'localhost') {
        return `${protocol}//localhost:8083/api`;
    } else if (host.includes('lpgrow.com')) {
        return `${protocol}//${host}/api`; // 动态适应 www.lpgrow.com 或 lpgrow.com
    } else {
        throw new Error('Unsupported hostname');
    }
};

const apiClient = axios.create({
    baseURL: getBaseUrl(),
    timeout: 5000000,
});

// 请求拦截器 - 可用于在发送请求之前进行一些预处理
apiClient.interceptors.request.use(
    config => {
        // 如果有认证token等全局headers可以在这里添加
        return config;
    },
    error => Promise.reject(error)
);

// 响应拦截器 - 可用于在接收到响应之后进行一些后处理
apiClient.interceptors.response.use(
    response => response.data, // 直接返回数据部分
    error => {
        console.error('API call failed:', error);
        // 这里可以选择性地做更多错误处理，比如重试机制
        throw error; // 重新抛出错误以保持链式调用
    }
);

// 统一错误处理函数
const handleError = (error) => {
    // 根据需要自定义错误处理逻辑
    if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        console.error('Server responded with status:', error.response.status);
    } else if (error.request) {
        // 请求已发出，但没有收到响应
        console.error('No response received:', error.request);
    } else {
        // 发送请求时发生了一些事情，触发了异常
        console.error('Error setting up request:', error.message);
    }
    throw error; // 重新抛出错误以保持链式调用
};

// 定义API端点
const MOVIES_API_URL = '/movies';
const CATEGORIES_API_URL = '/categories';
const COMMENTS_API_URL = '/comments';
const VISIT_COUNT_API_URL = '/count'; // 新增的访问计数API端点
const INCREMENT_VISIT_COUNT_API_URL = '/increment'; // 新增的增加访问计数API端点

// 获取电影列表
export const fetchMovies = async () => {
    try {
        return await apiClient.get(MOVIES_API_URL);
    } catch (error) {
        handleError(error);
    }
};

// 获取分类列表
export const fetchCategories = async () => {
    try {
        return await apiClient.get(CATEGORIES_API_URL);
    } catch (error) {
        handleError(error);
    }
};

// 获取单个电影详情
export const fetchMovieById = async (id) => {
    try {
        return await apiClient.get(`${MOVIES_API_URL}/${id}`);
    } catch (error) {
        handleError(error);
    }
};

// 增加播放次数
export const incrementPlayCount = async (movieId) => {
    try {
        return await apiClient.post(`${MOVIES_API_URL}/${movieId}/incrementPlayCount`);
    } catch (error) {
        handleError(error);
    }
};

// 添加评论
export const postComment = async (movieId, commentData) => {
    try {
        return await apiClient.post(`${COMMENTS_API_URL}/movies/${movieId}`, commentData);
    } catch (error) {
        handleError(error);
    }
};

// 获取评论
export const fetchComments = async (movieId) => {
    try {
        return await apiClient.get(`${COMMENTS_API_URL}/movies/${movieId}`);
    } catch (error) {
        handleError(error);
    }
};

// 创建新类别
export const createCategory = async (categoryData) => {
    try {
        return await apiClient.post(`${CATEGORIES_API_URL}`, categoryData);
    } catch (error) {
        handleError(error);
    }
};

// 上传视频
export const uploadMovie = async (formData) => {
    try {
        return await apiClient.post(`${MOVIES_API_URL}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (error) {
        handleError(error);
    }
};

// 根据类别ID获取电影列表
export const fetchMoviesByCategory = async (categoryId) => {
    try {
        return await apiClient.get(`/movies/category/${categoryId}`);
    } catch (error) {
        handleError(error);
    }
};

// 获取访问计数
export const fetchVisitCount = async () => {
    try {
        return await apiClient.get(VISIT_COUNT_API_URL);
    } catch (error) {
        handleError(error);
    }
};

// 增加访问计数
export const incrementVisitCount = async () => {
    try {
        return await apiClient.post(INCREMENT_VISIT_COUNT_API_URL);
    } catch (error) {
        handleError(error);
    }
};